import Base from '@studiometa/js-toolkit';

/**
 * @typedef {Object} LoaderRef
 * @property {HTMLElement} intro
 * @property {HTMLElement} message
 * @property {HTMLElement[]} sentence[]
 */

/**
 * @typedef {Object} LoaderInterface
 * @property {LoaderRef} $refs
 */

/**
 * Homepage class.
 */
export default class Loader extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Loader',
    refs: ['intro', 'message', 'sentence[]'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Loader & LoaderInterface}
   */
  mounted() {}

  /**
   * Unbind all events on destroy.
   *
   * @this {Loader & LoaderInterface}
   * @return {Loader} The Loader instance.
   */
  destroyed() {
    return this;
  }
}
